
<template>
  <div class="courseColumn">
    <div class="stydyItem" v-for="(item, index) in dataList" :key="index">
      <div class="stydyItemLeft" v-if="isSet">
        <img
          src="./../../../assets/school/check.png"
          v-if="item.check"
          @click="unCheck(item)"
        />
        <img
          src="./../../../assets/school/unselected1.png"
          v-if="!item.check"
          @click="check(item)"
        />
      </div>
      <div
        class="stydyItemRight"
        @click="toCourseDetails(item.is_valid, item.id, item.type, item)"
      >
        <div class="stydyItemRightTop">
          <div class="img" :class="{ specialImg: item.type == 1 }">
            <van-image
                width="100%"
                height="100%"
                radius="4px"
                fit="cover"
                :src="item.image"
              />
          </div>
          <!-- <img
            :src="item.image"
            class="img"
            :class="{ specialImg: item.type == 1 }"
          /> -->
          <img
            v-if="item.type == 3"
            src="./../../../assets/school/picturetext.png"
            class="tag"
          />
          <img
            v-if="item.type == 2"
            src="./../../../assets/school/video.png"
            class="tag"
          />
          <img
            v-if="item.type == 4"
            src="./../../../assets/school/audio.png"
            class="tag"
          />
          <div class="special" v-if="item.type == 1"></div>
        </div>
        <div class="stydyItemRightBtm">
          <p>{{ item.title }}</p>
          <div class="itemTip isStudy" v-if="isStudy">
            <div>
              <van-progress
                :percentage="item.percentage ? item.percentage : 0"
                stroke-width="6"
                color="linear-gradient(81deg, #B6D3FF 0%, #4E7DF7 100%)"
                track-color="#E1E9FA"
                :show-pivot="false"
              />
            </div>
            <span>已学{{ item.percentage ? item.percentage : 0 }}%</span>
          </div>
          <div v-if="!isStudy" class="itemTip notStudy">
            <span>免费</span>
            <span>{{ item.total_study_num }}次学习</span>
          </div>
        </div>
        <!-- 失效 -->
        <div class="valid" v-if="item.is_valid == false">
          <img src="./../../../assets/school/valid.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否是学信中心
    isStudy: {
      type: Boolean,
      default: false,
    },
    // 数据列表
    dataList: {
      type: Array,
      required: true,
    },
    // 是否可以设置移除
    isSet: {
      type: Boolean,
      default: false,
    },
    // 是否是预览
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    check(item) {
      this.$emit("check", item);
    },
    unCheck(item) {
      this.$emit("unCheck", item);
    },
    toCourseDetails(valid, id, type, item) {
      // 管理设置移除
      if (this.isSet) {
        if (item.check) {
          this.$emit("unCheck", item);
        } else {
          this.$emit("check", item);
        }
      } else {
        // 课程
        if (!this.isPreview) {
          if (valid == false) {
            this.$toast("此课程已失效");
          } else {
            let path;
            let channel = 2;
            switch (type) {
              case 1:
                path = "/school/courseDetailsSpecial";
                channel = 1;
                break;
              case 2:
                path = "/school/courseDetailsVideo";
                break;
              case 3:
                path = "/school/courseDetailsPicture";
                break;
              case 4:
                path = "/school/courseDetailsAudio";
                break;
              default:
              // console.log(type);
            }
            this.$router.push({
              path: path,
              query: {
                id: id,
                channel: channel,
              },
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.courseColumn {
  margin-bottom: -24px;
}
.stydyItem {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.stydyItemLeft {
  width: 32px;
  display: flex;
  align-items: center;
}
.stydyItemLeft img {
  width: 20px;
  height: 20px;
}

.stydyItemRight {
  flex: 1;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.stydyItemRightTop {
  width: 105px;
  height: 71px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.stydyItemRightTop .img {
  width: 105px;
  height: 70px;
  background-color: #ffffff;
  position: absolute;
  /* border-radius: 4px;
  top: 0;
  left: 0; */
  z-index: 2;
}
.stydyItemRightTop .specialImg {
  height: 66px;
  margin-top: 5px;
  background-color: #ffffff;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #DFE1EC;
}
.stydyItemRightTop .tag {
  width: 40px;
  height: 14px;
  position: absolute;
  top: 4px;
  left: 6px;
  z-index: 3;
}
.stydyItemRightTop .special {
  width: 90px;
  height: 70px;
  background-color: #dfe1ec;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.stydyItemRightBtm {
  flex: 1;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stydyItemRightBtm p {
  color: #404247;
  font-size: 15px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  margin-top: 2px;
}
.stydyItemRightBtm .itemTip {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}
/* 失效 */
.stydyItemRight .valid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
}
.stydyItemRight .valid img {
  width: 50px;
  height: 50px;
  margin-left: 16px;
}
/* 是学习中心 */
.isStudy > div {
  width: 88px;
  margin-right: 8px;
}
.isStudy span {
  color: #9ca1ad;
  font-size: 11px;
}
/* 不是学习中心 */
.notStudy {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notStudy > span:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #eb4872;
}
.notStudy > span:last-child {
  font-size: 12px;
  font-weight: 400;
  color: #9ca1ad;
}
</style>